// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"fb7b5386","199":"961ca981","261":"c9f13f1c","275":"1286ff68"}[chunkId] + ".chunk.css";
};